import {Directive, Input} from '@angular/core';
import {AbstractControl, NG_VALIDATORS, Validator} from '@angular/forms';
import {TranslateService} from '@ngx-translate/core';

@Directive({
  selector: '[validateStartEndTimeInterval]',
  providers: [{provide: NG_VALIDATORS, useExisting: ValidateStartEndTimeIntervalDirective, multi: true}]
})
export class ValidateStartEndTimeIntervalDirective implements Validator {
  // @Input() forbiddenName: string;
  @Input() allowEmpty =  false;

  constructor (private translate: TranslateService) {}

  validate(control: AbstractControl): {[key: string]: any} {

    const value = control.value;
    return this.validateString(value);
    // return this.forbiddenName ? forbiddenNameValidator(new RegExp(this.forbiddenName, 'i'))(control)
    //   : null;
  }

  validateString( value: string): {[key: string]: any} {

    if (!value) {
      if (this.allowEmpty){
        return null;
      }

      let msg = 'wrong.format.HH:MM-HH:MM';
      if (this.translate) {
        msg = this.translate.instant(msg);
      }
      return {['validateStartEndTimeInterval']: msg };
    }

    const idxSeparator = value.indexOf('-');
    if (idxSeparator < 0) {
      let msg = 'wrong.format.HH:MM-HH:MM';
      if (this.translate) {
        msg = this.translate.instant(msg);
      }
      return {['validateStartEndTimeInterval']: msg };
    }
    const startTime = this.parseTime(value.substr(0, idxSeparator));
    const endTime = this.parseTime(value.substr(idxSeparator + 1));
    if ( !startTime || !endTime ){
      let msg = 'wrong.format.HH:MM-HH:MM';
      if (this.translate) {
        msg = this.translate.instant(msg);
      }
      return {['validateStartEndTimeInterval']: msg };
    }

    return null;
  }

  /**
     This method should not be called before the value has been verified.
   */

  retrieveDateTime( value: string): [{h: number, m: number},{h: number, m: number}] {
    const idxSeparator = value.indexOf('-');
    const startTime = this.parseTime(value.substr(0, idxSeparator));
    const endTime = this.parseTime(value.substr(idxSeparator + 1));
    return [startTime, endTime];
  }


  parseTime(value: string): {h: number, m: number} {

    if (!value) {
      return null;
    }

    const idxSeparator = value.indexOf(':');
    if (idxSeparator < 0) {
      return null;
    }
    let amTime = false;
    if (value.toUpperCase().indexOf('AM') > 0) {
      amTime = true;
    }
    let pmTime = false;
    if (value.toUpperCase().indexOf('PM') > 0) {
      pmTime = true;
    }
    let hour =  parseInt(value.substr(0, idxSeparator), 10);
    if (amTime && hour > 12) {
      return null;
    }
    if (hour === 12){
      if (amTime){
        hour = 0;
      }
    }else{
      if (pmTime) {
        hour += 12;
      }
    }
    const minutes = parseInt(value.substr(idxSeparator + 1),  10);
    if (hour <= 24 && hour >= 0) {
      if (minutes >= 0 && minutes <= 59) {
         return {h: hour, m: minutes};
      }
    }
    return null;
  }


}
